import Vue from 'vue/dist/vue.min.js';
import cmgSimulator from './mixins/cmgSimulator';
import { dayjs } from '../components/dayjs-localized';

export function createCmgSimulatorPerson() {
  return new Vue({
    el: '#paje-simulator-person',
    mixins: [cmgSimulator],
    data() {
      return {
        shared_cost_toggle: false,
        shared_cost: '0',
        has_overtime_fifty: false,
        monthly_overtime_fifty: '0',
        increase_overtime_fifty: '50', // for above 48h to 50h
        gross_hourly_wage: '10.35',
        grossHourlyWageInput: '10,35',
        minimumGrossHourlyWage: 10.35,
        maximumGrossHourlyWage: 40.00,
        maxNormalWorkingHours: 40,
        maxOvertimeForty: 48,
        maxOvertimeFifty: 50,
        firstEmployeeDeclaration: false,
        taxesCreditAmount: {
          increase: 1500,
          firstYear: {
            min: 15000,
            max: 18000,
          },
          otherYears: {
            min: 12000,
            max: 15000,
          },
        },
        socialContributionMaximumCmgAmount: {
          0: 463,
          3: 232,
          6: 0,
        },
      };
    },
    watch: {
      firstEmployeeDeclaration: function() {
        const $item = $('.cmg-simulator-ged__first-employee-declaration');
        $item.prop('checked', this.firstEmployeeDeclaration);
        $item.change();
      },
      shared_cost_toggle: function() {
        const $item = $('input.cmg-simulator-ged__shared-cost-toggle');
        $item.prop('checked', this.shared_cost_toggle);
        $item.change();
      },
      weekly_hours: function() {
        this.monthFromWeek();

        this.has_overtime = this.weekly_hours_f > this.maxNormalWorkingHours;
        this.has_overtime_fifty = this.weekly_hours_f > this.maxOvertimeForty;

        this.checkErrors();
      },
      has_overtime: function() {
        const $item = $('.toggle.planned_overtime');
        $item.prop('checked', this.has_overtime);
        $item.change();
        const that = this;
        setTimeout(function() {
          that.checkErrors();
        });
      },
      children() {
        this.updateTooltip();
      },
      grossTotal() {
        this.updateTooltip();
      },
      social_contributions_employer() {
        this.updateTooltip();
      },
      situation_french() {
        this.updateTooltip();
      },
      child_age_french() {
        this.updateTooltip();
      },
      tranches() {
        this.updateTooltip();
      },
      child_age(value) {
        if (value === '6') {
          this.youngestChildAge = 'six-or-more';
        }
      },
    },
    computed: {
      monthlyOvertimeFloat() {
        return this.monthlyOvertimeForty + this.monthlyOvertimeFifty;
      },
      monthlyOvertimeForty: function() {
        return this.isMonth
          ? parseFloat(this.monthly_overtime.replace(',', '.'))
          : (this.weeklyOvertimeFloat / this.weekly_worked_days_f * this.monthly_worked_days_f);
      },
      monthlyOvertimeFifty: function() {
        return this.isMonth
          ? parseFloat(this.monthly_overtime_fifty.replace(',', '.'))
          : (this.weekly_overtime_fifty_f / this.weekly_worked_days_f * this.monthly_worked_days_f);
      },
      weeklyOvertimeFloat() {
        return this.has_overtime ? this.weekly_hours_f - this.maxNormalWorkingHours - this.weekly_overtime_fifty_f : 0;
      },
      weekly_overtime_fifty_f: function() {
        return this.has_overtime_fifty ? this.weekly_hours_f - this.maxOvertimeForty : 0;
      },
      increase_overtime_fifty_i: function() {
        return Number(this.increase_overtime_fifty);
      },
      dividedGrossHourlyWage: function() {
        return this.shared_cost_toggle
          ? parseFloat(this.shared_cost.replace(',', '.')) / 100 * this.gross_hourly_wage_f
          : this.gross_hourly_wage_f;
      },
      netHourlyWage() {
        return this.dividedGrossHourlyWage * this.net_ratio_classic;
      },
      grossMonthlyWageRegular() {
        return this.regular_hours * this.dividedGrossHourlyWage;
      },
      grossMonthlyOvertimeWage() {
        return this.has_overtime ? this.monthlyOvertimeFloat * this.dividedGrossHourlyWage : 0;
      },
      grossMonthlyOvertimeWagePremium() {
        let monthlyOvertimeIncrease = this.has_overtime
          ? this.monthlyOvertimeForty * this.dividedGrossHourlyWage * this.increase_overtime_i / 100
          : 0;
        monthlyOvertimeIncrease += this.has_overtime_fifty
          ? this.monthlyOvertimeFifty * this.dividedGrossHourlyWage * this.increase_overtime_fifty_i / 100
          : 0;
        return monthlyOvertimeIncrease;
      },
      cmgUnavailable: function() {
        return this.cmgAidToggle === 'no' || this.youngestChildTooOld;
      },
      /**
       * Abattement de charge patronales
       * this charge of 2 € is applied on 90% of the total normal hours worked and 100% on overtime worked
       * this value is capped to the remaining of the employer social contribution
       * @returns {number}
       */
      employerContributionsReduction: function() {
        const possibleEmployerReduction = Math.ceil(this.regular_hours * 0.9 * 2) + this.monthlyOvertimeFloat * 2;
        const maxPossibleReduction = Math.max(this.social_contributions_employer - this.socialContributionsCredit, 0);
        return Math.min(possibleEmployerReduction, maxPossibleReduction);
      },
      maxSocialContributionCmgAmount() {
        return this.socialContributionMaximumCmgAmount[parseInt(this.child_age_option)];
      },
      isCalculable() {
        if (this.month_week === 'month') {
          if (!this.is_monthly_hours || !this.is_monthly_worked_days) return false;
          if (this.has_overtime && !this.is_monthly_overtime) return false;
          if (this.has_overtime && (this.monthlyOvertimeFloat > this.monthly_hours_f)) return false;
          if (!this.isWeeklyHours || !this.is_weekly_worked_days || !this.isYearlyWeeks) return false;
        } else if (this.month_week === 'week') {
          if (!this.isWeeklyHours || !this.is_weekly_worked_days || !this.isYearlyWeeks) return false;
        }

        return this.month_week !== 'other';
      },
      isWeeklyHours() {
        return this.weekly_hours !== '' && this.weekly_hours_f >= 0 && this.weekly_hours_f <= 50;
      },
      isYearlyWeeks() {
        return this.yearly_weeks !== '' && this.yearly_weeks_f <= 52;
      },
      /**
       * As in GED we should be in full year the vacation paid should always be in the monthly salary
       */
      netVacationsMonthly() {
        return 0;
      },
      grossVacationsMonthly() {
        return 0;
      },
      grossTotal() {
        return this.gross_mensualization + this.grossVacationsMonthly + this.grossMonthlyOvertimeWagePremium;
      },
      total_amount: function() {
        return this.grossTotal + this.social_contributions_employer;
      },
      /**
       * Social contribution credit
       * In terms of GED we only take the social contribution of the employer which can be paid up to 50%
       * and to a maximum of 463 € depending on the child age
       * @returns {number|number}
       */
      socialContributionsCredit() {
        return this.cmgUnavailable
          ? 0
          : Math.min(this.social_contributions_employer / 2,
            this.maxSocialContributionCmgAmount);
      },
      /**
       * The tax credit takes 50% of your expenses and the expenses are capped depending on cases.
       * It may be increased for the number of children that the parent have
       * For the first year of declaration the ceil must be increased
       * @returns {number}
       */
      creditTaxCeil: function() {
        const increaseAmount = this.children * this.taxesCreditAmount.increase;
        const amountFirstYear = Math.min((this.taxesCreditAmount.firstYear.min + increaseAmount),
          this.taxesCreditAmount.firstYear.max);
        const amountOtherYears = Math.min((this.taxesCreditAmount.otherYears.min + increaseAmount),
          this.taxesCreditAmount.otherYears.max);
        return (this.firstEmployeeDeclaration ? amountFirstYear : amountOtherYears) / 2;
      },
    },
    methods: {
      cmgAmount(rangeIndex) {
        let amount;
        if (this.child_age_option === '6' || this.cmgUnavailable) {
          amount = 0;
        } else {
          const divideMaxAMount = this.cmgAidToggle === 'partial' ? 2 : 1;
          const maximumAmount = this.maximum_amount(rangeIndex) / divideMaxAMount;
          const perceivableAmount = ((
            this.net_mensualization +
              this.net_monthy_overtime_increase +
              this.netVacationsMonthly
          ) * 0.85) / divideMaxAMount;
          amount = Math.min(maximumAmount, perceivableAmount);
        }
        return amount;
      },
      remainingAmount: function(i) {
        return (
          this.total_amount -
            this.socialContributionsCredit -
            this.cmgAmount(i) -
            this.employerContributionsReduction -
            this.other_aid_f
        );
      },
      /**
       * Taxes credit
       * We need to get the total of the expenses over the year for the employer
       * Total salary + Total contribution by employer - Abatement Employer charges - Aids for social contribution - CMG aids - other aids
       * Only 50% of the expenses will be used as taxes credit
       * This calculation is made for the year and the amount that can be paid is ceiled to 12000 € depending on cases
       * @param i
       * @returns {number}
       */
      taxesCredit(i) {
        return Math.min(
          Math.max(
            (
              this.grossTotal +
                    this.social_contributions_employer -
                    this.employerContributionsReduction -
                    this.socialContributionsCredit -
                    this.cmgAmount(i) -
                    this.other_aid_f
            ) * 12 / 2,
            0
          ), this.creditTaxCeil
        );
      },
      weekFromMonth() {
        if (this.is_monthly_overtime) {
          const weeklyOvertime =
              this.is_weekly_worked_days && this.is_monthly_worked_days
                ? ((this.monthlyOvertimeFloat / this.monthly_worked_days_f) * this.weekly_worked_days_f)
                : 0;

          this.weekly_hours = this.is_monthly_hours && this.is_weekly_worked_days && this.is_monthly_worked_days
            ? (
                (
                  (this.monthly_hours_f - this.monthlyOvertimeFloat) /
                      this.monthly_worked_days_f * this.weekly_worked_days_f
                ) + weeklyOvertime
              ).toFixed(2).toString().replace('.', ',')
            : '40';
        } else {
          this.weekly_hours = this.is_monthly_hours && this.is_weekly_worked_days && this.is_monthly_worked_days
            ? (
                this.monthly_hours_f / this.monthly_worked_days_f * this.weekly_worked_days_f
              ).toFixed(2).toString().replace('.', ',')
            : '40';
        }
      },
      isSocialContributionRelevant(name) {
        const contribution = this.social_contributions[name];

        if (contribution.care_type !== 'person' && contribution.care_type !== '') return false;
        if (typeof contribution.alsace_moselle_specific !== 'undefined' && !this.alsace_moselle) return false;
        if (typeof contribution.start_date !== 'undefined' && dayjs() < dayjs(contribution.start_date)) return false;
        if (typeof contribution.end_date !== 'undefined' && dayjs() > dayjs(contribution.end_date)) return false;

        return true;
      },
      checkErrors() {
        $('.wrapper_input.simulator_weekly_worked_days .input-group')
          .toggleClass('is-invalid', !this.is_weekly_worked_days);
        $('.wrapper_input.simulator_weekly_hours .input-group').toggleClass('is-invalid', !this.isWeeklyHours);
        $('.wrapper_input.simulator_yearly_weeks .input-group').toggleClass('is-invalid', !this.isYearlyWeeks);
        $('.wrapper_input.simulator_monthly_worked_days .input-group')
          .toggleClass('is-invalid', !this.is_monthly_worked_days);
        $('.wrapper_input.simulator_monthly_hours .input-group').toggleClass('is-invalid', !this.is_monthly_hours);
        $('.wrapper_input.simulator_monthly_overtime .input-group')
          .toggleClass('is-invalid', !this.is_monthly_overtime);
      },
      createWageSlider() {
        const that = this;
        // Non-linear slider : on fait en sorte que le taux horaire puisse avoir un maximum très haut, sans impacter l'ensemble du slider
        // eslint-disable-next-line no-undef
        this.slider = noUiSlider.create(document.getElementById('paje-simulator-slider'), {
          start: this.gross_hourly_wage_f,
          tooltips: [true],
          connect: 'lower',
          range: {
            min: this.minimumGrossHourlyWage,
            '75%': this.minimumGrossHourlyWage * 1.5,
            max: this.maximumGrossHourlyWage,
          },
          step: 0.01,
          format: {
            to: function(value) {
              return '<b>' + that.to_money(value) + '</b><br /> ' +
                  '<span class=\'font--xs\'>(' + that.to_money(value * that.net_ratio_classic) + ' net)</span>';
            },
            from: function(value) {
              return value;
            },
          },
        });
        $('#simulator_gross_hourly_wage').val(this.minimumGrossHourlyWage);
        this.slider.on('update', function(label, key, value) {
          that.gross_hourly_wage = that.toFloatForDisplay(value[0], 2);
          if (!that.hourlyWageSetFromInput) {
            that.grossHourlyWageInput = that.gross_hourly_wage;
          }
        });
      },
      updateTooltip() {
        const tooltips = [
          {
            elementId: '#cmg-simulator-ged__total-monthly-payment',
            contentId: '#cmg-simulator-ged__total-monthly-payment-details',
          },
          {
            elementId: '#cmg-simulator-ged__aids-link',
            contentId: '#cmg-simulator-ged__aids-details',
          },
        ];
        tooltips.forEach(tooltip => {
          setTimeout(function() {
            $(tooltip.elementId).attr(
              'data-body',
              $(tooltip.contentId).html()
            );
          }, 500);
        });
      },
    },
    mounted() {
      this.$nextTick(function() {
        this.toggleMW();
        this.monthFromWeek();
        this.createWageSlider();
      });

      this.updateTooltip();
    },
  });
}
